import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "userCartItem";

export const userCartItemService = {
    getAllByUserCartId,
    remove
};

function getAllByUserCartId(userCartId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAllByUserCartId/?userCartId=${userCartId}`, requestOptions).then(handleResponse);
}

function remove(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Remove/?id=${id}`, requestOptions).then(handleResponse);
}

